import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-drepturi-si-obligatii',
  templateUrl: './drepturi-si-obligatii.component.html',
  styleUrls: ['./drepturi-si-obligatii.component.scss']
})
export class DrepturiSiObligatiiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
